if (!customElements.get('smile-review-layout')) {
  customElements.define('smile-review-layout', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      const text = (root, selector) => root.querySelector(selector)?.textContent.trim() || '';
      const key = (...values) => JSON.stringify(values.map(v => v.replace(/\s+/g, ' ').trim()));
      const records = new Map();
      this.querySelector('template[data-review-details]')?.content.querySelectorAll('.jdgm-rev').forEach(review => {
        const id = key(text(review, '.jdgm-rev__author'), text(review, '.jdgm-rev__title'), text(review, '.jdgm-rev__body'));
        const date = review.querySelector('.jdgm-rev__timestamp')?.getAttribute('data-content')?.slice(0, 10) || '';
        const detail = { date, reply: text(review, '.jdgm-rev__reply-content') };
        // Ambiguous duplicate reviews must not receive another review's metadata.
        records.set(id, records.has(id) ? null : detail);
      });
      const create = (tag, className, value) => {
        const element = document.createElement(tag);
        element.className = className;
        element.textContent = value;
        return element;
      };
      const update = () => {
        this.observer.disconnect();
        this.querySelectorAll('.jdgm-review-card').forEach(card => {
          const name = text(card, '.jdgm-review-card__reviewer-name');
          const title = text(card, '.jdgm-review-card__details-title');
          const body = text(card, '.jdgm-review-card__details-description');
          const rating = card.querySelector('.jm-star-rating');
          if (!name || !rating) return;
          const detail = records.get(key(name, title, body));
          const signature = JSON.stringify([name, title, body, rating.getAttribute('aria-label'), detail]);
          const old = card.querySelector('.sr-review-copy');
          if (old?.dataset.signature === signature) return;
          const copy = create('div', 'sr-review-copy', '');
          copy.dataset.signature = signature;
          copy.append(create('strong', 'sr-review-author', name));
          if (/^\d{4}-\d{2}-\d{2}$/.test(detail?.date || '')) {
            const date = create('time', 'sr-review-date', detail.date.replaceAll('-', '/'));
            date.dateTime = detail.date;
            copy.append(date);
          }
          const stars = rating.cloneNode(true);
          stars.classList.add('sr-review-rating');
          copy.append(stars, create('p', 'sr-review-body', body || title));
          if (detail?.reply) {
            const reply = create('div', 'sr-review-reply', '');
            reply.append(create('small', 'sr-review-reply-label', 'Store replied:'), create('p', '', detail.reply));
            copy.append(reply);
          }
          if (old) old.replaceWith(copy); else card.append(copy);
          card.classList.add('sr-review-enhanced');
        });
        this.observer.observe(this, { childList: true, subtree: true, characterData: true });
      };
      this.observer = new MutationObserver(update);
      update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
    }
  });
}
